import React, { createElement } from 'react';
import { Helmet } from 'react-helmet';
import { LandingPage } from './pages/LandingPage';
function App() {
  return <>
      <Helmet data-id="element-0">
        <title data-id="element-1">Mega Pack Física en Acción - Recursos para Docentes</title>
        <meta name="description" content="Sistema completo de proyectos, experiencias y evaluaciones listas para usar para docentes de Física." data-id="element-2" />

        {/* Meta Pixel Code */}
        <script data-id="element-3">
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1181648490064668');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript data-id="element-4">
          {`<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=1181648490064668&ev=PageView&noscript=1"
          />`}
        </noscript>
        {/* End Meta Pixel Code */}
      </Helmet>

      <LandingPage data-id="element-5" />
    </>;
}
export { App };